import React from "react";
import FormField from "@adsk/alloy-react-form-field";
import Tooltip from "@adsk/alloy-react-tooltip";
import { AlertInformationIcon } from "@adsk/alloy-react-icon";
import { Control } from "@adsk/alloy-react-dropdown-v2";
import { TypeDisplayWithHydration } from "@adsk/acc-issues-common/components/input/TypeDropdown/TypeDisplayWithHydration";
import { FIELD_WRAPPER_STYLE } from "@adsk/acc-issues-core/utils/styles/consts";
import { useTranslations } from "@adsk/acc-issues-translations";

export const FixedTypeField = ({
  typeId,
  errorMessage,
}: {
  typeId: string;
  errorMessage?: string;
}) => {
  const { T } = useTranslations();
  return (
    <FormField
      style={{
        ...FIELD_WRAPPER_STYLE,
        overflowWrap: "anywhere",
      }}
      label={T.translate("issueAttributes.issueType")}
      labelVariant={FormField.LABEL_VARIANTS.TOP}
      renderInfoPopover={() => {
        return (
          <Tooltip
            placement={Tooltip.PLACEMENTS.RIGHT}
            variant={Tooltip.VARIANTS.DARK}
            content={T.translate("issueCreation.disabledReason.fixedType")}
          >
            <AlertInformationIcon size={16} style={{ marginLeft: 2 }} />
          </Tooltip>
        );
      }}
      data-testid="type-field"
      error={errorMessage}
    >
      <Control
        disabled
        isOpen={false}
        selectedItem={null}
        getToggleButtonProps={() => {
          return {};
        }}
        renderPlaceholder={() => {
          return <TypeDisplayWithHydration typeId={typeId} />;
        }}
      />
    </FormField>
  );
};
